import { IonButton, IonCol, IonRow, IonText } from "@ionic/react";

import { useEffect, useState } from "react";
import { makePATCHRequest, makePOSTRequest } from "../../request/rawRequest";
import "../IonColor/color.css";
import Quizz from "../Quizz/Quizz";
import BasicPage from "../baseComponents/basicPage/BasicPage";
import Reader from "./Reader";
import ReaderButton from "./ReaderButton";
import Synthesis from "./Synthesis";
import "./Video.css";
import NextTheme from "./nextTheme";
import NextVideo from "./nextVideo";

interface ContainerProps {
  endpoint: string;
  pathLogo: string;
}

export type QuizzBack = {
  awnser: string[];
  question: string;
  valide: string[];
};

export type VideoBackType = {
  _id: string;
  name: string;
  link: string;
  viewed: boolean;
  quizz: QuizzBack[];
  synthesis: any;
  pages: number[];
  fileUrl: string;
};

const defaultType: VideoBackType = {
  _id: "",
  name: "",
  link: "",
  viewed: false,
  quizz: [],
  synthesis: { words: [], link: "", title: "" },
  pages: [],
  fileUrl: "",
};

export const titleSection = (title: string, subtitle?: string) => {
  const split = title.split(" ");
  const number = split[0];
  let titleClear = "";

  for (let i = 1; i < split.length; i++) {
    titleClear += split[i] + " ";
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        marginTop: "20px",
      }}
    >
      <IonText color="dark">
        <h3>
          <span>{number} </span>
          <span style={{ color: "var(--ion-color-secondary)" }}>
            {titleClear}
          </span>
        </h3>
      </IonText>
      <span
        style={{
          textAlign: "center",
          color: "black",
          fontSize: 20,
          paddingBottom: 10,
        }}
      >
        {subtitle}
      </span>
    </div>
  );
};

const displayQuizz = (videoEnd: boolean, video: VideoBackType) => {
  if (video?.quizz?.length <= 0)
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <IonButton shape="round" color="dark" disabled>
          Disponible Prochainement
        </IonButton>
      </div>
    );

  if (
    videoEnd ||
    (["prim", "char"].includes(localStorage.getItem("techno") ?? "") &&
      video.viewed)
  )
    return <Quizz questions={video.quizz} _id={video._id} />;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        color: "black",
      }}
    >
      Finis l'activité d'abord
    </div>
  );
};

const VideoDisplay: React.FC<ContainerProps> = ({ pathLogo }) => {
  const [videoEnd, setVideoEnded] = useState<boolean>(false);
  const [video, setVideo] = useState<VideoBackType>(defaultType);
  const urlParams = new URLSearchParams(window.location.search);
  const isSpecial = urlParams.get("compID") === null;
  let videoList: VideoBackType = defaultType;

  const setVideoViewed = async () => {
    await makePATCHRequest(`/video/viewed?id_video=${urlParams.get("id")}`);
  };

  const isCharOrPrim =
    localStorage.getItem("techno") === "char" ||
    localStorage.getItem("techno") === "prim";

  const onHitLastPage = () => {
    if (isCharOrPrim) {
      setVideo((old) => ({ ...old, viewed: true }));
      setVideoEnded(true);
      setVideoViewed();
    }
  };

  const fetchVideo = async () => {
    await makePOSTRequest("/videos", { _id: urlParams.get("id") })
      .then((res) => res[0])
      .then((data) => {
        const test: VideoBackType = {
          _id: data._id,
          name: data.name,
          link: data.link,
          viewed: data.viewed,
          quizz: data.quizz,
          synthesis:
            data.synthesis === undefined
              ? { words: [], link: "", title: "" }
              : data.synthesis,
          pages: data.pages,
          fileUrl: data.fileUrl ?? "",
        };
        videoList = test;
        setVideo(videoList);
      });
  };

  useEffect(() => {
    if (video._id === "") {
      fetchVideo();
    }
    setVideoEnded(video.viewed);
  }, [video]);

  return (
    <BasicPage
      pathLogo={pathLogo}
      subtitle=""
      title={video.name}
      pathReturn="/competences"
    >
      {isCharOrPrim ? (
        <ReaderButton video={video} isChar={isCharOrPrim} />
      ) : (
        <IonRow>
          <IonCol>
            {titleSection("1 Le cours en vidéo :", "visionnage obligatoire")}

            <video
              autoPlay={false}
              controls={true}
              onContextMenu={(e) => {
                e.preventDefault();
              }}
              onEnded={() => {
                setVideoEnded(true);
                setVideoViewed();
              }}
              controlsList="nodownload"
              className="video"
              src={video.link}
            >
              <source src={video.link} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </IonCol>
        </IonRow>
      )}
      <IonRow className="ion-justify-content-left">
        {titleSection("2 Les quiz : ", "teste tes connaissances")}
      </IonRow>
      {videoEnd ||
      (["prim", "char"].includes(localStorage.getItem("techno") ?? "") &&
        video.viewed) ? (
        <Quizz questions={video?.quizz ?? undefined} _id={video._id} />
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            color: "black",
          }}
        >
          Finis l'activité d'abord
        </div>
      )}

      {!isCharOrPrim && <ReaderButton video={video} isChar={isCharOrPrim} />}
      {localStorage.getItem("techno") !== "char" ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <IonRow className="ion-justify-content-start">
            {titleSection(
              (isCharOrPrim ? "3" : "4") + " La synthèse : ",
              "approfondis tes connaissances"
            )}
          </IonRow>
          <IonRow
            className="ion-justify-content-center"
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
            }}
          >
            <Synthesis
              label="Exerces-toi"
              idVideo={video._id}
              data={video.synthesis}
            />
          </IonRow>
        </div>
      ) : null}
      <IonRow
        className="ion-justify-content-center"
        style={{
          padding: "40px 0 20px 0",
        }}
      >
        {isSpecial ? (
          <NextVideo
            idTheme={urlParams.get("theme") ?? ""}
            idVideo={video._id}
          />
        ) : (
          <NextTheme
            idTheme={urlParams.get("theme") ?? ""}
            idVideo={video._id}
            idComp={urlParams.get("compID") ?? ""}
          />
        )}
      </IonRow>
      <Reader
        title={video.name}
        pages={video.pages}
        url={video.fileUrl ?? ""}
        onHitLastPage={onHitLastPage}
      />
    </BasicPage>
  );
};

export default VideoDisplay;
